<dialog-draggable-header>Reason Codes</dialog-draggable-header>

<div mat-dialog-content>
   <data-table [data]="reasons" [columns]="columns" (select)="onGridSelectionChange($event)"
      (edit)="saveHandler($event)" [loading]="loading" [paging]="true" [pageSize]="pageOptions.size"
      [defaultSortField]="pageOptions.sort" [totalRecords]="total" [lazy]="true" (lazyLoad)="onLazyLoad($event) "
      [lazyLoadOnInit]="true" [filterColumnDisplay]="false">
      <ng-container actionStart>
         <button mat-button (click)="onAddReasonClick()" [disabled]="data.reSourced" matTooltip="Click to add a reason.">Add Reason</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <button mat-button (click)="removeHandler()" [disabled]="data.reSourced" matTooltip="Click to delete the selected reason.">Delete Reason</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <mat-label class="display-field"> Checking Fixture No:
            <span class="text-danger">{{fixtureNo}}</span>
         </mat-label>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <mat-label class="display-far"> Part No Lh or Single:
            <span class="text-danger">{{partNumber}}</span>
         </mat-label>
      </ng-container>
      <ng-container actionEnd>
         <button mat-dialog-close mat-button>Close</button>
      </ng-container>
   </data-table>
</div>
